var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 460,
    viewBox: "0 0 425 460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.038 2.14689C206.611 0.740406 209.529 0 212.5 0C215.471 0 218.389 0.740406 220.962 2.14689L416.538 109.137C421.783 111.995 425 117.285 425 123.019V336.981C425.001 339.796 424.219 342.561 422.734 344.998C421.248 347.435 419.111 349.458 416.538 350.863L220.962 457.853C218.389 459.26 215.471 460 212.5 460C209.529 460 206.611 459.26 204.038 457.853L8.45319 350.863C5.8815 349.457 3.74625 347.433 2.26232 344.996C0.778376 342.559 -0.00190042 339.795 3.47582e-06 336.981V123.019C3.47582e-06 117.293 3.21655 111.995 8.46185 109.137L204.029 2.14689H204.038Z",
    fill: "url(#paint0_linear_106_17)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_17",
    x1: 425.243,
    y1: 271.769,
    x2: -14.9613,
    y2: 191.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#284EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#224192",
    stopOpacity: 0.17
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHex);
export default __webpack_public_path__ + "static/media/hex.f6018fe31a91c1fc8c3c859245772a14.svg";
export { ForwardRef as ReactComponent };